import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
/**
 * Applies an operator's module restriction to the routes, not just the sidebar
 * (empty allowed_modules = all modules). Admins and super admins pass through.
 */
export function ModuleRoute({ modules }) {
    const { user } = useAuth();
    const roles = user?.roles ?? [];
    const isOperatorOnly = roles.includes('ROLE_OPERATOR')
        && !roles.includes('ROLE_ADMIN_COMMUNE')
        && !roles.includes('ROLE_SUPER_ADMIN');
    const allowed = user?.allowed_modules ?? [];
    if (isOperatorOnly && allowed.length > 0 && !modules.some((m) => allowed.includes(m))) {
        return _jsx(Navigate, { to: "/commune", replace: true });
    }
    return _jsx(Outlet, {});
}
